import clsx from "clsx";

type UnpublishedChangesIndicatorProps = {
  className?: string;
  dataTestId?: string;
};

export const UnpublishedChangesIndicator = ({
  className,
  dataTestId,
}: UnpublishedChangesIndicatorProps) => (
  <div
    data-testid={dataTestId}
    className={clsx(
      "flex items-center justify-center h-[1.6rem] w-[1.6rem] rounded-full bg-yellow-150/50 shrink-0",
      className,
    )}
  >
    <div className="h-[0.8rem] w-[0.8rem] rounded-full bg-yellow-450" />
  </div>
);
